import { config } from '../config.js';

/**
 * Faixa no topo de todas as telas fora de PRD ("Ambiente de testes"), para ninguém confundir DEV com produção.
 * Em PRD não aparece. A faixa empurra o cabeçalho para baixo (soma na área segura do topo), não cobre nada.
 */
const TEXT = { dev: 'Ambiente de testes · DEV', local: 'Ambiente local' };

export function envBanner() {
  if (config.appEnv === 'prd') return;
  const bar = document.createElement('div');
  bar.className = 'env-banner';
  bar.setAttribute('role', 'note');
  bar.textContent = TEXT[config.appEnv] ?? `Ambiente ${config.appEnv}`;
  document.body.prepend(bar);
  document.documentElement.classList.add('has-env-banner');
}
